import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalService, PhoneFilterPipe } from '@boels/helpers';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'boels-request-quote-modal',
  templateUrl: './request-quote-modal.component.html',
  styleUrls: ['./request-quote-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, FontAwesomeModule, PhoneFilterPipe],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['form'],
    },
  ],
})
export class RequestQuoteModalComponent {
  modalService = inject(ModalService);

  phoneNumber?: string;
  phoneRate?: string;
  email?: string;

  faPhone = faPhone;
  faEnvelope = faEnvelope;

  closeModal(): void {
    this.modalService.close();
  }
}
